import Swal from "sweetalert2";

export default function alert(options: any) {
    return Swal.fire({ ...options, heightAuto: false })
}

export function Redirect({ navigate, location, goBack = false }: any) {
    alert({
        showCloseButton: true,
        showLoaderOnConfirm: true,
        showCancelButton: true,
        title: "Not logged In",
        text: "Do you want to login ?"
    }).then((value: any) => {
        if (value.isConfirmed) {
            typeof navigate === "function" && navigate({
                pathname: "/login",
                search: `?redirectUrl=${location.pathname}${location.search}`,
            });
        } else {
            goBack && navigate(-1)
        }
    })
}